import { Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { SubfrotaService } from 'src/app/subFrota/subfrota.service';
import { IFiltroSubFrotaModel, ISubFrotaModel, IVeiculoSubFrotaModel } from 'src/app/subFrota/model/subFrota.model';
import { subscribeOn, Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { LoginModel } from 'src/app/model/login.model';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-subfrota-show',
  templateUrl: './subfrota-show.component.html',
  styleUrls: ['./subfrota-show.component.scss']
})
export class SubfrotaShowComponent implements OnInit, OnDestroy {

  usuario !: LoginModel | undefined;

  private subs = new Subscription();

  loading = 0;
  isDelete = false;

  subFrota!: ISubFrotaModel;

  displayedColumns = ['placa', 'apelido', 'anoFabricacao', 'marca', 'modelo', 'combustivel', 'status'];

  filtro!: IFiltroSubFrotaModel;

  public dataSource!: MatTableDataSource<IVeiculoSubFrotaModel>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private subFrotaService: SubfrotaService,
    private authenticationService: AuthenticationService,
    private snackBar: SnackBarService,
    private renderer: Renderer2,
    private router: Router) {

  }

  ngOnInit(): void {

    // Liga a animação de Loading (Spinner) na tela 
    this.loading++;

    this.usuario = this.subFrotaService?.usuario;

    // Verifica se o guid do usuário é ou continua válido.
    this.authenticationService.validate(this.subFrotaService?.usuario?.retorno?.guid ?? '')
      .then((dados => {

        if (!dados.sucesso) {

          this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
          this.usuario = undefined;

        } else {

          this.iniciar();

        }
      }))
      .catch(() => {
        this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
      })
      .finally(() => {
        this.loading--;
      });
  }

  private iniciar() {
    this.renderer.addClass(document.body, this.usuario?.retorno?.aparencia ?? 'PADRAO');

    this.isDelete = this.router.url === '/subfrota/excluir' ? true : false;

    if (this.subFrotaService.codigoSubFrota) {

      this.filtro = { guid: this.subFrotaService.usuario.retorno.guid, codigoSubFrota: this.subFrotaService.codigoSubFrota };

      this.obter();
      if (!this.isDelete) {
        this.carregarVeiculos();
      }
    }

    else
      this.router.navigateByUrl('/subfrota');
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  obter() {

    this.loading++;

    this.subs.add(this.subFrotaService.obter(this.filtro)
      .subscribe({
        next: (res) => {
          if (res?.sucesso) {
            this.subFrota = res.retorno;
          }
        },
        complete: () => {
          this.loading--;
        }
      }));
  }

  excluir() {
    var result = confirm("Deseja realmente excluir esta sub-frota?");

    if (result) {
      this.loading++;
      this.subFrota.guid = this.subFrotaService.usuario.retorno.guid;
      this.subs.add(this.subFrotaService.excluir(this.subFrota)
        .subscribe({
          next: (res) => {
            if (res?.sucesso) {
              this.snackBar.flashMessage('Sub-Frota excluída com sucesso.', ['snackbar-info'], 'Fechar', 0);
              this.router.navigateByUrl('/subfrota');
            } else {
              this.snackBar.flashMessage(res.mensagens[0], ['snackbar-error'], 'Fechar', 0);
            }
          },error: (err) => {this.snackBar.flashMessage('Não foi possível excluir a SubFrota.', ['snackbar-error'], 'Fechar', 0);}
          ,complete: () => {
            this.loading--;
          }
        }));
    }
  }


  private carregarVeiculos() {

    this.loading++;

    this.subs.add(this.subFrotaService.listVeiculos(this.filtro)
      .subscribe({
        next: (res) => {
          if (res?.sucesso) {
            this.dataSource = new MatTableDataSource<IVeiculoSubFrotaModel>(res.retorno);
            this.dataSource.paginator = this.paginator;
            this.sort.sort(({ id: '', start: 'desc' }) as MatSortable);
            this.dataSource.sort = this.sort;
            this.sort.sort(({ id: 'placa', start: 'asc' }) as MatSortable);
            this.sort.disableClear = true;
            this.dataSource.sort = this.sort;
          }
        },
        complete: () => {
          this.loading--;
        }
      }));
  }

  getXLSName(): string {
    const now = new Date();

    var name = 'CTF_ConsultaVeiculosSubFrotas' + this.subFrotaService.usuario.retorno.codigoEntidade + '_'
      + this.subFrotaService.usuario.retorno.nomeFantasia + '_'
      + this.subFrotaService.usuario.retorno.login + '_'
      + now.toISOString();

    return name;
  }

  ngOnDestroy() {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

}
